import React, { useState, useEffect, useRef } from 'react';
import { SoupLaModerna } from './SoupLaModerna';


const SoupSimulator = () => {
    // 1. Estado simulado del UI (Lo que controlaría el Admin)
    const [ui, setUi] = useState({ uiStatus: "Cover", scale: 100 });
    
    // 2. Estado simulado del Juego (Lo que mandaría la API)
    const [gameState, setGameState] = useState({
        matchId: "mock-123",
        status: "Waiting",
        target: 400, // Supongamos que 400 taps llenan un plato
        zones: [
            { zone: "canels", currentBalloonTaps: 0, completedBalloons: 0 },
            { zone: "tecate", currentBalloonTaps: 0, completedBalloons: 0 },
            { zone: "nissan", currentBalloonTaps: 0, completedBalloons: 0 }
        ],
        winners: null
    });

    const simulationInterval = useRef(null);

    // Función para simular que miles de personas están jugando
    const startRandomTaps = () => {
        if (simulationInterval.current) clearInterval(simulationInterval.current);
        
        simulationInterval.current = setInterval(() => {
            setGameState(prev => {
                const newZones = prev.zones.map(z => {
                    // ¡CAMBIO 2! Ráfagas masivas (Prueba de estrés)
                    // Simulamos que el 90% del tiempo están tapeando (alta concurrencia)
                    if (Math.random() > 0.1) {
                        // Llegan entre 80 y 250 taps de golpe cada 300ms
                        const incomingTaps = Math.floor(Math.random() * 170) + 80;
                        const newTaps = z.currentBalloonTaps + incomingTaps; 
                        const target = prev.target;
                        
                        if (newTaps >= target) {
                            // Calculamos si con esta ráfaga masiva llenaron 1 o MÁS platos de golpe
                            const platesFilled = Math.floor(newTaps / target);
                            const leftoverTaps = newTaps % target;
                            
                            return {
                                ...z,
                                completedBalloons: z.completedBalloons + platesFilled,
                                currentBalloonTaps: leftoverTaps
                            };
                        }
                        return { ...z, currentBalloonTaps: newTaps };
                    }
                    return z;
                });
                return { ...prev, zones: newZones };
            });
        }, 300); // El WebSocket "late" cada 300ms
    };

    const stopTaps = () => {
        if (simulationInterval.current) clearInterval(simulationInterval.current);
    };

    // Botones de control manual
    const handleShowIntro = () => setUi({ ...ui, uiStatus: "Cover" });
    const handleStartGame = () => {
        setUi({ ...ui, uiStatus: "Running" });
        setGameState(prev => ({ ...prev, status: "Running" }));
        startRandomTaps();
    };
    const handleStopGame = () => {
        stopTaps();
        setGameState(prev => ({ 
            ...prev, 
            status: "Finished",
            winners: { winnerType: "single", winners: ["canels"] } // Forzamos a Canel's a ganar
        }));
    };

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh' }}>
            
            {/* PANEL DE CONTROL FLOTANTE (Solo para ti como desarrollador) */}
            <div style={{ 
                position: 'absolute', top: 10, left: 10, zIndex: 9999, 
                background: 'rgba(0,0,0,0.8)', padding: 15, borderRadius: 8, color: 'white' 
            }}>
                <h4 style={{ margin: '0 0 10px 0' }}>🎮 Mando Simulador</h4>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={handleShowIntro}>1. Mostrar Intro</button>
                    <button onClick={handleStartGame}>2. Iniciar Juego (Taps Automáticos)</button>
                    <button onClick={handleStopGame}>3. Terminar Juego (Gana Player 1)</button>
                </div>
            </div>

            {/* AQUI RENDERIZAMOS EL COMPONENTE REAL, PASÁNDOLE LOS DATOS FALSOS */}
            <SoupLaModerna 
                state={gameState} 
                ui={ui} 
                isActiveWomensMode={false} 
            />
        </div>
    );
};

export { SoupSimulator };
























// import React, { useState, useEffect, useRef } from 'react';
// import { SoupLaModerna } from './SoupLaModerna';


// const SoupSimulator = () => {
//     // 1. Estado simulado del UI (Lo que controlaría el Admin)
//     const [ui, setUi] = useState({ uiStatus: "Cover", scale: 100 });
    
//     // 2. Estado simulado del Juego (Lo que mandaría la API)
//     const [gameState, setGameState] = useState({
//         matchId: "mock-123",
//         status: "Waiting",
//         target: 15, // Supongamos que 15 taps llenan un plato
//         zones: [
//             { zone: "canels", currentBalloonTaps: 0, completedBalloons: 0 },
//             { zone: "tecate", currentBalloonTaps: 0, completedBalloons: 0 },
//             { zone: "nissan", currentBalloonTaps: 0, completedBalloons: 0 }
//         ],
//         winners: null
//     });

//     const simulationInterval = useRef(null);

//     // Función para simular que miles de personas están jugando
//     const startRandomTaps = () => {
//         if (simulationInterval.current) clearInterval(simulationInterval.current);
        
//         simulationInterval.current = setInterval(() => {
//             setGameState(prev => {
//                 const newZones = prev.zones.map(z => {
//                     // Solo el 60% de las veces este jugador recibe taps en este instante (para que no se vean iguales)
//                     if (Math.random() > 0.4) {
//                         const newTaps = z.currentBalloonTaps + Math.floor(Math.random() * 3) + 1; // Suma de 1 a 3 taps
//                         const target = prev.target;
                        
//                         // Si llenó el plato
//                         if (newTaps >= target) {
//                             return {
//                                 ...z,
//                                 completedBalloons: z.completedBalloons + 1,
//                                 currentBalloonTaps: newTaps - target // Lo que sobró
//                             };
//                         }
                        
//                         // Si solo acumuló
//                         return { ...z, currentBalloonTaps: newTaps };
//                     }
//                     return z;
//                 });
//                 return { ...prev, zones: newZones };
//             });
//         }, 300); // Entran datos cada 300ms (como un socket rápido)
//     };

//     const stopTaps = () => {
//         if (simulationInterval.current) clearInterval(simulationInterval.current);
//     };

//     // Botones de control manual
//     const handleShowIntro = () => setUi({ ...ui, uiStatus: "Cover" });
//     const handleStartGame = () => {
//         setUi({ ...ui, uiStatus: "Running" });
//         setGameState(prev => ({ ...prev, status: "Running" }));
//         startRandomTaps();
//     };
//     const handleStopGame = () => {
//         stopTaps();
//         setGameState(prev => ({ 
//             ...prev, 
//             status: "Finished",
//             winners: { winnerType: "single", winners: ["canels"] } // Forzamos a Canel's a ganar
//         }));
//     };

//     return (
//         <div style={{ position: 'relative', width: '100vw', height: '100vh' }}>
            
//             {/* PANEL DE CONTROL FLOTANTE (Solo para ti como desarrollador) */}
//             <div style={{ 
//                 position: 'absolute', top: 10, left: 10, zIndex: 9999, 
//                 background: 'rgba(0,0,0,0.8)', padding: 15, borderRadius: 8, color: 'white' 
//             }}>
//                 <h4 style={{ margin: '0 0 10px 0' }}>🎮 Mando Simulador</h4>
//                 <div style={{ display: 'flex', gap: '10px' }}>
//                     <button onClick={handleShowIntro}>1. Mostrar Intro</button>
//                     <button onClick={handleStartGame}>2. Iniciar Juego (Taps Automáticos)</button>
//                     <button onClick={handleStopGame}>3. Terminar Juego (Gana Player 1)</button>
//                 </div>
//             </div>

//             {/* AQUI RENDERIZAMOS EL COMPONENTE REAL, PASÁNDOLE LOS DATOS FALSOS */}
//             <SoupLaModerna 
//                 state={gameState} 
//                 ui={ui} 
//                 isActiveWomensMode={false} 
//             />
//         </div>
//     );
// };

// export { SoupSimulator };